import { AnchorHTMLAttributes, FC, Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import isLinkToAnotherWorld from '../../utils/is-link-to-another-world';
import isPrerender from '../../utils/is-prerender';

type DomainSensitiveLinkProps = {
    href: string;
    key?: string;
    omitForBots?: boolean;
    children?: ReactNode | Record<string, string>;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const DomainSensitiveLink: FC<DomainSensitiveLinkProps> = (props) => {
    const { children, href, key = '', omitForBots, ...restProps } = props;

    const sensitive = isLinkToAnotherWorld(href);

    if (omitForBots && isPrerender()) {
        return <>{children}</>;
    }

    return (
        <Fragment key={key}>
            {sensitive && (
                <a {...restProps} href={href}>
                    {children}
                </a>
            )}
            {!sensitive && (
                <Link {...restProps} to={href}>
                    {children}
                </Link>
            )}
        </Fragment>
    );
};

export default DomainSensitiveLink;
